// extracted by mini-css-extract-plugin
module.exports = {"button":"QobdKy","icon":"SwuIFf"};